import { Input } from '@payaca/ambrosia';
import { FC } from 'react';
import { FieldProps } from './fieldInputTypes';

export const EmailFieldInput: FC<FieldProps<'email'>> = (props) => {
  const { value, onChange } = props;

  return <Input value={value ?? ''} onChange={onChange} />;
};
